type PlainObject = Record<string, unknown>;

/**
 * Grava um valor no objeto, por chave simples ("status") ou caminho pontuado ("params.startDate")
 * Muta o objeto recebido e devolve a mesma referência 
 *
 * @param object - Objeto alterado no lugar
 * @param path - Caminho separado por ponto
 * @param newValue - Valor gravado na última parte do caminho
 * @returns O próprio objeto recebido
 */
export const updateValue = <T>(object: T, path: string, newValue: unknown): T => {
  const parts = path.split(".");
  let value: unknown = object;
  let index = 0;

  for (const part of parts) {
    if (index + 1 === parts.length) {
      (value as PlainObject)[part] = newValue;
    } else if (value && typeof value === "object") {
      value = (value as PlainObject)[part] || {};
    } else {
      throw new Error(`Path "${path}" is invalid.`);
    }
    index++;
  }

  return object;
};
